import React, {
  forwardRef,
  PureComponent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Layout, Menu, Drawer } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { checkMobile } from "../../common/utils/utils-device";
import { useResize } from "../../hooks/useResize";

const { Sider } = Layout;

const MenuDrawer = () => {
  const auth = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  const roles = useMemo(() => {
    return !!auth && !!auth.roles ? auth.roles[0] : null;
  }, [auth]);

  return (
    <Menu mode="inline">
      <Menu.Item
        key="/"
        icon={
          <img
            alt=""
            className="anticon anticon-desktop"
            style={styles.icon}
            src={require("../../assets/icons/white_envelope.png")}
          />
        }
        className={pathname === "/" ? "activeBackground" : ""}
      >
        <Link style={{ color: "#fff" }} to="/">
          Danh sách hợp đồng
        </Link>
      </Menu.Item>

      <Menu.Item
        key="/customer"
        icon={
          <img
            alt=""
            style={{ ...styles.icon, width: "1.5em", height: "unset" }}
            className="anticon anticon-desktop"
            src={require("../../assets/icons/white-users-solid.png")}
          />
        }
        className={pathname === "/customer" ? "activeBackground" : ""}
      >
        <Link style={{ color: "#fff" }} to="/customer">
          Danh sách khách hàng
        </Link>
      </Menu.Item>
      {roles !== "Sale" && (
        <Menu.Item
          key="/journey-diary"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/journey-diary.png")}
            />
          }
          className={pathname === "/journey-diary" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/journey-diary">
            Nhật ký hành trình
          </Link>
        </Menu.Item>
      )}
      {roles !== "Sale" ? (
        <Menu.Item
          key="/vehicle"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/white-car-solid.png")}
            />
          }
          className={pathname === "/vehicle" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/vehicle">
            Quản lý xe
          </Link>
        </Menu.Item>
      ) : null}
      {roles !== "Sale" ? (
        <Menu.Item
          key="/driver"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/driver.png")}
            />
          }
          className={pathname === "/driver" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/driver">
            Quản lý tài xế
          </Link>
        </Menu.Item>
      ) : null}
      {roles !== "Sale" ? (
        <Menu.Item
          key="/summary-report"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/report.png")}
            />
          }
          className={pathname === "/summary-report" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/summary-report">
            Báo cáo tổng hợp
          </Link>
        </Menu.Item>
      ) : null}
      {roles !== "Sale" && roles !== "Admin" && (
        <Menu.Item
          key="/user-account"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/team.png")}
            />
          }
          className={pathname === "/user-account" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/user-account">
            Phân quyền người dùng
          </Link>
        </Menu.Item>
      )}
      {roles !== "Sale" && (
        <Menu.Item
          key="/review"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/star.png")}
            />
          }
          className={pathname === "/review" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/review">
            Nhận xét đánh giá
          </Link>
        </Menu.Item>
      )}
    </Menu>
  );
};

export const SideBar = ({ onCollapse, setOnCollapse }) => {
  if (checkMobile() || window.innerWidth <= 997) {
    return (
      <Drawer
        title="DRAW"
        placement={"left"}
        closable={false}
        onClose={() => setOnCollapse(false)}
        visible={onCollapse}
      >
        <MenuDrawer />
      </Drawer>
    );
  }

  return (
    <div className="content">
      <Sider
        collapsedWidth={0}
        className="site-layout-background"
        width={280}
        collapsible
        collapsed={onCollapse}
      >
        <MenuDrawer />
      </Sider>
    </div>
  );
};

const styles = {
  icon: {
    width: "1.3em",
    height: "1.3em",
    marginRight: 25,
    objectFit: "contain",
  },
};
